module.exports = __webpack_public_path__ + "img/undraw_coolness_dtmq.96de8150.svg";